var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn() && !_vm.state.user)?_c('app-loading'):(_vm.useAppLayout)?_c('app-page-layout',[_c('router-view',{key:_vm.$route.path})],1):_c('router-view',{key:_vm.$route.path})
}
var staticRenderFns = []

export { render, staticRenderFns }